export const DocumentNote = ({
  className,
  strokeColor = 'currentColor',
}: {
  className?: string
  strokeColor?: string
}) => (
  <svg
    className={className}
    fill='none'
    height='12'
    viewBox='0 0 12 12'
    width='12'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.625 11L11 6.625M6.625 11V7.25C6.625 7.08424 6.69085 6.92527 6.80806 6.80806C6.92527 6.69085 7.08424 6.625 7.25 6.625H11M6.625 11H2.25C1.91848 11 1.60054 10.8683 1.36612 10.6339C1.1317 10.3995 1 10.0815 1 9.75V2.25C1 1.91848 1.1317 1.60054 1.36612 1.36612C1.60054 1.1317 1.91848 1 2.25 1H9.75C10.0815 1 10.3995 1.1317 10.6339 1.36612C10.8683 1.60054 11 1.91848 11 2.25V6.625'
      fill='none'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
